import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as actions from "../../store/programs/actions";
import TableGridView from "../../components/TableGridView";
import Filterform from "./Filterform";
import "./style.scss";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import { withStyles } from "@material-ui/styles";
import Switch from '@material-ui/core/Switch';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteForeverRoundedIcon from '@material-ui/icons/DeleteForeverRounded';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import { arabicConvertor } from "../../utils/Shared";
const MySwitch = withStyles((theme) => ({
  root: {
    width: 38,
    height: 22,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: "#FFF",
      '& + $track': {
        backgroundColor: '#24D7D3',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#24D7D3',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 20,
    height: 20,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[400],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

const Programs = ({ intl: { messages } }) => {
  const dispatch = useDispatch();
  const [searchValues, setSearchValues] = useState({});
  const lang = localStorage.getItem("lang") || "en";
  const { programs } = useSelector((state) => state.programs);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [blockConfirmation, setBlockConfirmation] = useState(false);
  const [cancelConfirmation, setCancelConfirmation] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState({});
  const [myData, setMyData] = useState([]);
  const [formData, setFormData] = useState({
      en: "",
      ar: "",
  });

  useEffect(() => {
    //Get internal Users list
    dispatch(
      actions?.getProgramsRequest({
        page: 1,
        sort: "created_at,desc",
      })
    );
    return () => {
      dispatch(actions.getProgramsReceive([]));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //set MyData

  useEffect(() => {
    if (programs?.data) {
      setMyData(programs.data);
    }
  }, [programs]);

  const createNewProgram = (e) => {
    e.preventDefault();
    if (!myData.find((item) => item.is_new === true)) {
        setSelectedProgram(null)
        setMyData([...myData, {
          id: Math.random(),
          name: {
            en: "",
            ar: "",
          },
          is_new: true,
          is_active: true,
        }])
        setFormData({
          en: "",
          ar: "",
        })
        setTimeout(() => {
          document.getElementById('programNameEn').focus();
        }, 100);
    }
  }

  const editProgram = (program) => {
    // Clear Function
    if ((selectedProgram)) {
        setMyData(myData.map(item => {
            item.is_new = false;
            return item;
        }))
    } else {
        if (myData.find(item => item.is_new === true)) {
          return
        };
    }
    setTimeout(() => {
      // Edit Function
      setSelectedProgram(program);
      setFormData({
        en: program.name.en,
        ar: program.name.ar,
      })
      setMyData(myData.map(item => {
        if (item.id === program.id) {
          item.is_new = true;
        }
        return item;
      }))
      document.getElementById('programNameEn').focus();
    }, 50);
  }

  //table n grid view render
  const headings = [
    messages.programs.en_name,
    messages.programs.ar_name,
    messages.programs.status,
    messages.programs.actions,
  ];

  const renderTableData = () => {
    return myData?.map((program, i) => {
      const {
        id,
        name,
        is_active,
        is_new,
      } = program;

      let programNameEn;
      let programNameAr;
      if (is_new) {
        programNameEn = (
            <input className="myInput" type="text" placeholder={messages.programs.en_name} id="programNameEn"
                   value={formData.en} onChange={(e) => {
                      setFormData({ ...formData, en: e.target.value })
                      document.getElementById('programNameEn').style.borderColor = '#eee';
            }} />
        );
        programNameAr = (
            <input className="myInput" type="text" placeholder={messages.programs.ar_name} id="programNameAr"
                   value={formData.ar} onChange={(e) => {
                      setFormData({ ...formData, ar: arabicConvertor(e.target.value) })
                      document.getElementById('programNameAr').style.borderColor = '#eee';
            }}/>
        );
      } else {
        programNameEn = name.en;
        programNameAr = name.ar;
      }

      let programStatus;
      if (is_active === 1) {
        programStatus = true;
      } else {
        programStatus = false;
      }

      return [
        programNameEn,
        programNameAr,
        !is_new ? (<MySwitch checked={programStatus} name="block" onChange={() => {
          if (programStatus) {
            setSelectedProgram(program);
            setBlockConfirmation(true);
          } else {
            dispatch(actions.activeProgramRequest(program.id));
          }
        }} />) 
        : <button className="tableBtn cancel" onClick={(e) => {
            e.preventDefault();
            if ((selectedProgram)) {
              if (selectedProgram.name.en === formData.en && selectedProgram.name.ar === formData.ar) {
                setMyData(myData.map(item => {
                  if (item.id === program.id) {
                    item.is_new = false;
                  }
                  return item;
                }))
                setFormData({
                  en: "",
                  ar: "",
                });
              } else {
                setCancelConfirmation(true);
              }
            } else {
              if (formData.en.length > 0 || formData.ar.length > 0) {
                setCancelConfirmation(true);
              } else {
                setMyData(myData.filter(item => item.is_new !== true));
              }
            }
        }}>{messages.programs.cancel}</button>,
        !is_new ? (<div className="actions-icons">
          <EditRoundedIcon onClick={() => {
            editProgram(myData.find(item => item.id === id));
          }} />
          <DeleteForeverRoundedIcon onClick={() => {
            setSelectedProgram(program);
            setDeleteConfirmation(true);
          }}/>
        </div>) : 
        <button className="tableBtn" onClick={(e) => {
            e.preventDefault();
            
            if (formData.en.length > 0 && formData.ar.length > 0) {
              let payload = {
                id: 0,
                name: {
                  en: formData.en,
                  ar: formData.ar
                }
              }
              if (selectedProgram && selectedProgram.id) {
                payload.id = selectedProgram.id
                setTimeout(() => {
                  dispatch(actions.editProgramRequest(payload));
                }, 200);
              } else {
                dispatch(actions.addProgramRequest(payload));
              }
            } else {
              if (formData.ar.length === 0) {
                document.getElementById('programNameAr').style.borderColor = '#e35454c2';
                document.getElementById('programNameAr').focus();
              }
              if (formData.en.length === 0) {
                document.getElementById('programNameEn').style.borderColor = '#e35454c2';
                document.getElementById('programNameEn').focus(); 
              } 
            }
            
        }}>{messages.programs.save}</button>,
      ];
    });
  };

  const handlePageChange = (e, page) => {
    return dispatch(
      actions?.getProgramsRequest({
        page,
        sort: "created_at,desc",
        ...searchValues,
      })
    );
  };
 
  return (
    <>
      {programs ? (
        <div style={{ padding: '5px 0'}}>
          <button className={`myBtn ${lang === 'ar' && 'rtl'}`} 
              onClick={(e) => createNewProgram(e)} >
              <AddCircleOutlineOutlinedIcon />{messages.programs.add_new}
          </button>
          <TableGridView
            title={
              <>
                <FormattedMessage
                  values={{
                    total: programs?.data?.length,
                    totals: programs?.total,
                  }}
                  id="programs.program_of"
                  defaultMessage={messages.programs.program_of}
                />
              </>
            }
            Form={<Filterform setSearchValues={setSearchValues} />}
            table={{
              stickyHeader: true,
              headings: headings,
              data: renderTableData(),
              headClass: "bg-white table-head",
              noData: messages.noData.no_data,
            }}
            //gridView={renderGridView}
            pagination={{
              count: programs.last_page,
              page: programs.current_page,
              handleChange: handlePageChange,
            }}
            programs={true}
          />
        </div>
      ) : null}
  
      <ConfirmDialog show={deleteConfirmation} 
                     onCancel={() => {
                        setDeleteConfirmation(false)
                      }}
                     onConfirm={() => {
                        dispatch(actions.deleteProgramRequest(selectedProgram.id))
                        setDeleteConfirmation(false);
                     }}
                     content={messages.programs.delete_confirmation}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />

      <ConfirmDialog show={blockConfirmation} 
                     onCancel={() => {
                        setBlockConfirmation(false)
                      }}
                     onConfirm={() => {
                        dispatch(actions.desactiveProgramRequest(selectedProgram.id))
                        setBlockConfirmation(false);
                     }}
                     content={messages.programs.block_confirmation}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
      
      <ConfirmDialog show={cancelConfirmation} 
                     onCancel={() => {
                        setCancelConfirmation(false)
                      }}
                     onConfirm={() => {
                       if (selectedProgram) {
                        setMyData(myData.map(item => {
                          item.is_new = false;
                          return item;
                        }))
                       } else {
                        setMyData(myData.filter(item => item.is_new !== true));
                       }
                       setCancelConfirmation(false);
                       setFormData({
                        en: "",
                        ar: "",
                      });
                     }}
                     content={messages.warningMsgs.warning_close_window}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
    </>
  );
};

export default injectIntl(Programs);
